import { flexCenter } from '@anm/styles/helpers';
import styled from 'styled-components';

export const TitleSecondLine = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;
export const Title = styled.h1`
  display: flex;
  text-align: center;
  font-weight: 900;
  font-size: 40px;
  line-height: 50px;
  color: #292a2b;
  flex-direction: column;
  margin: 0;
`;

export const Description = styled.div`
  font-weight: 400;
  font-size: 20px;
  line-height: 50px;
  text-align: center;
  color: #292a2b;
`;

export const Underline = styled.span`
  display: inline-flex;
  position: relative;
  margin: 0 10px;
  white-space: nowrap;

  span {
    position: relative;
    z-index: 3;
  }
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    width: calc(100% + 10px);
    height: 18px;
    left: -5px;
    z-index: 1;
    background: #ffea00;
  }
`;

export const New = styled.div`
  display: inline-flex;
  padding: 2px 5px;
  width: 41px;
  height: 24px;

  background: #ffea00;
  border-radius: 5px;

  position: absolute;
  right: 0;
  top: 0;
  transform: translate(120%, 0);

  &:after {
    content: 'New!';
    font-weight: 800;
    font-size: 12px;
    line-height: 20px;
    color: #292a2b;

    ${flexCenter}
  }
`;

const Wrapper = styled.div`
  margin-bottom: 20px;
`;

export default Wrapper;
